import { createAction } from 'typesafe-actions';

import { Rebuffer } from '../constants';

interface IncrementCanPlayCountPayload {
  displayAd: $TSFixMe;
  trackToken: string;
}

/**
 * Emitted during playback when the audio player calculates it has enough content
 *  to play audio w/o further rebuffers. In an ideal case this will happen only
 *  once on initial audio load.
 *  We want to know how often it happens and what display ad is active at the time.
 *  This, along with additional actions logged can help determine whether display ads
 *    are impacting audio playback.
 *
 * @param {Map} displayAd - active display ad
 * @param {String} trackToken - current track
 */
export const incrementCanPlayCount = createAction(
  Rebuffer.RebufferActions.INCREMENT_CAN_PLAY_COUNT,
  (displayAd: $TSFixMe, trackToken: string) => ({ displayAd, trackToken }),
)<IncrementCanPlayCountPayload>();
export type IncrementCanPlayCountAction = ReturnType<typeof incrementCanPlayCount>;

/**
 * Resets the canPlayThrough even count. Normally when a track completes
 *  playing.
 */
export const resetCanPlayCount = createAction(
  Rebuffer.RebufferActions.RESET_TRACK_CAN_PLAY_COUNT,
)();
export type ResetTrackCanPlayCountAction = ReturnType<typeof resetCanPlayCount>;
